<i18n>
{
  "fr": {
      "complianceSurveyOnly": "Enquête de conformité seule",
      "town": "Commune",
      "street": "Rue",
      "numberStreet": "Numéro de police",
      "zipCode": "Code postal",
      "creationDate": "Date de création ",
      "propertyType": "Type de propriété ",
      "contact": "Contact - N°{number}",
      "addContact": "Ajouter un contact",
      "requriedField": "Champ obligatoire",
      "loading": "Chargement...",
      "responsibleFolder": "Personne en charge du dossier",
      "propertyTypeOther":"Autres",
      "folderNumber" : "Numéro de dossier",
      "estimatedNumberOfResident":"Estimation du nombre d’équivalent habitant "
  }
}
</i18n>

<template>
  <div>
    <div class="panel panel-info property-forms">
      <div class="panel-heading">{{ title }}</div>
      <div class="panel-body">
        <div class="block">
          <b-form-group
            v-if="propertyFolderNumber"
            :label="$t('folderNumber')"
            class="txt-strong"
            label-cols="5"
          >
            <label>{{propertyFolderNumber}}</label>
          </b-form-group>
          <b-form-group :label="$t('responsibleFolder')" label-cols="5" label-for="responsibleId">
            <template v-if="loaderResponsibleData">
              <strong>{{$t('loading')}}</strong>
              <b-spinner class="ml-auto"></b-spinner>
            </template>
            <b-form-select
              name="responsibleId"
              v-model="propertyForm.responsibleId"
              size="sm"
              plain
            >
              <option value="null">--</option>
              <option
                v-for="user in getUsers"
                :key="user.id"
                :value="user.id"
              >{{ user.firstName }} {{ user.lastName }}</option>
            </b-form-select>
          </b-form-group>
          <b-form-group
            label-class="required"
            :label="$t('complianceSurveyOnly')"
            label-cols="5"
            label-for="complianceSurveyOnly"
          >
            <b-form-radio-group
              buttons
              v-model="propertyForm.complianceSurveyOnly"
              :options="optionsCompliance"
              size="lg"
              button-variant="outline-info"
              :name="$t('complianceSurveyOnly')"
              required
              :state="Boolean(propertyForm.complianceSurveyOnly)"
            />
            <b-form-invalid-feedback
              :state="Boolean(propertyForm.complianceSurveyOnly)"
              class="invalid-feedback"
            >{{ $t('requriedField') }}</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group
            label-class="required"
            :label="$t('town')"
            label-cols="5"
            label-for="townProperty"
          >
            <multiselect
              id="townProperty"
              v-model="propertyForm.town"
              name="townProperty"
              :options="getTowns"
              track-by="id"
              label="label"
              deselect-label
              select-label
              :custom-label="customLabel"
            />

            <b-form-invalid-feedback
              :state="Boolean(propertyForm.town)"
              class="invalid-feedback"
            >{{ $t('requriedField') }}</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label-cols="5" label-size="md">
            <autocomplete
              :disableInput="!Boolean(propertyForm.town)"
              input-class="form-control form-control-multi"
              ref="autocomplete"
              :source="urlFunction"
              results-property="features"
              :results-display="formatDisplay"
              @selected="setXHRValue"
              :resultsValue="propertyForm.street"
              placeholder="veuillez saisir une adresse"
            ></autocomplete>
          </b-form-group>
          <b-form-group
            label-class="required"
            :label="$t('street')"
            label-cols="5"
            label-size="md"
            label-for="street"
          >
            <b-form-input
              id="street"
              name="street"
              type="text"
              :maxlength="$MAX_255"
              min="0"
              size="sm"
              class="form-control"
              v-model="propertyForm.street"
              required
              :state="Boolean(propertyForm.street)"
              disabled
            />
            <b-form-invalid-feedback
              :state="Boolean(propertyForm.street)"
              class="invalid-feedback"
            >{{ $t('requriedField') }}</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group
            label-class="required"
            :label="$t('numberStreet')"
            label-cols="5"
            label-size="md"
            label-for="numberStreet"
          >
            <b-form-input
              id="numberStreet"
              name="numberStreet"
              type="text"
              :maxlength="$MAX_255"
              size="sm"
              class="form-control"
              v-model="propertyForm.numberStreet"
              required
              :state="Boolean(propertyForm.numberStreet)"
            />
            <b-form-invalid-feedback
              :state="Boolean(propertyForm.numberStreet)"
              class="invalid-feedback"
            >{{ $t('requriedField') }}</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group
            label-class="required"
            :label="$t('zipCode')"
            label-cols="5"
            label-size="md"
            label-for="zipCode"
          >
            <b-form-input
              id="zipCode"
              name="zipCode"
              type="number"
              min="0"
              size="sm"
              class="form-control"
              v-model="propertyForm.zipCode"
              required
              :state="Boolean(propertyForm.zipCode)"
              disabled
            />
            <b-form-invalid-feedback
              :state="Boolean(propertyForm.zipCode)"
              class="invalid-feedback"
            >{{ $t('requriedField') }}</b-form-invalid-feedback>
          </b-form-group>

          <b-form-group
            :label="$t('creationDate')"
            label-cols="5"
            label-size="md"
            label-for="creationDate"
            class="form-table"
          >
            <b-form-input
              id="creationDate"
              name="creationDate"
              type="date"
              min="0"
              size="sm"
              class="form-control"
              v-model="propertyForm.creationDate"
            />
            <span class="input-group-addon">
              <i class="fa fa-calendar"></i>
            </span>
          </b-form-group>
          <b-form-group :label="$t('propertyType')" label-cols="5" label-for="propertyType">
            <multiselect
              id="propertyType"
              v-model="propertyForm.propertyType"
              name="propertyType"
              :loading="loaderData"
              :options="getPropertyTypes"
              :searchable="false"
              track-by="id"
              label="internalLabel"
            />
          </b-form-group>
          <b-form-group :label="$t('estimatedNumberOfResident')" label-cols="5" label-for="estimatedNumberOfResident">
              <b-form-input
                id="estimatedNumberOfResident"
                name="estimatedNumberOfResident"
                type="number"
                min="0"
                step="1"
                pattern="\d+"
                @keydown="isDigit($event)"
                @drop="$event.preventDefault()"
                :maxlength="$MAX_255" size="sm" class="form-control"
                v-model="propertyForm.conception.estimatedNumberOfResident" />
          </b-form-group>
          <b-form-group
            :label="$t('propertyTypeOther')"
            label-cols="5"
            label-size="md"
            label-for="propertyTypeOther"
            class="form-table"
          >

            <b-form-input
              id="propertyTypeOther"
              name="propertyTypeOther"
              type="text"
              :maxlength="$MAX_255"
              class="form-control"
              v-model="propertyForm.propertyTypeOther"
            />
          </b-form-group>
          <div
            class="panel panel-info"
            v-for="(contact, index) in propertyForm.contacts"
            :key="index"
            @click="currentContact(index)"
          >
            <div class="panel-heading">
              {{ $t('contact', { number: index + 1 }) }}
              <b-link class="pull-right" @click.stop="deleteContact(contact)">X</b-link>
            </div>
            <div class="panel-body">
              <b-form-group
                label-class="required"
                label="Type de contact"
                label-cols="4"
                label-for="typeContact"
              >
                <multiselect
                  id="typeContact"
                  v-model="contact.typeContact"
                  name="typeContact"
                  :options="options"
                  :allowEmpty="false"
                  :multiple="true"
                  :searchable="false"
                  track-by="value"
                  label="name"
                  :state="contact.typeContact.length >= 1"
                />

                <b-form-invalid-feedback
                  :state="contact.typeContact.length >= 1"
                  class="invalid-feedback"
                >{{ $t('requriedField') }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                label="Autre"
                label-cols="4"
                label-for="otherTypeContact"
                v-if="checkOtherContactType(contact.typeContact)"
              >
                <b-form-input
                  name="otherTypeContact"
                  type="text"
                  :maxlength="$MAX_255"
                  v-model="contact.otherTypeContact"
                />
              </b-form-group>
              <b-form-group label="Civilité" label-cols="4" label-for="title">
                <b-form-radio-group
                  buttons
                  v-model="contact.title"
                  :options="optionsGender"
                  size="lg"
                  button-variant="outline-info"
                  name="title"
                />
              </b-form-group>
              <b-form-group label-class="required" label="Nom" label-cols="4" label-for="name">
                <b-form-input
                  name="name"
                  type="text"
                  :maxlength="$MAX_255"
                  v-model="contact.name"
                  required
                  :state="Boolean(contact.name)"
                />
                <b-form-invalid-feedback
                  :state="Boolean(contact.name)"
                  class="invalid-feedback"
                >{{ $t('requriedField') }}</b-form-invalid-feedback>
              </b-form-group>
              <b-form-group label="Prénom" label-cols="4" label-for="firstName">
                <b-form-input
                  name="firstName"
                  type="text"
                  v-model="contact.firstName"
                  :maxlength="$MAX_255"
                />
              </b-form-group>
              <b-form-group label="Siret" label-cols="4" label-for="siret">
                <b-form-input name="siret" type="text" v-model="contact.siret" />
              </b-form-group>
              <b-form-group label="Raison sociale" label-cols="4" label-for="businessName">
                <b-form-input name="businessName" type="text" v-model="contact.businessName" />
              </b-form-group>
              <b-form-group label="Tél(fixe)" label-cols="4" label-for="fixedLinePhone">
                <b-form-input name="fixedLinePhone" type="tel" v-model="contact.fixedLinePhone" />
              </b-form-group>
              <b-form-group label="Tél(portable)" label-cols="4" label-for="mobilePhone">
                <b-form-input name="mobilePhone" type="tel" v-model="contact.mobilePhone" />
              </b-form-group>
              <b-form-group label="E-mail" label-cols="4" label-for="email">
                <b-form-input name="email" type="email" v-model="contact.email" />
              </b-form-group>
              <b-form-group label label-cols="4">
                <autocomplete
                  input-class="form-control form-control-multi"
                  ref="autocompleteTown"
                  :source="urlFunctionTown"
                  results-property="features"
                  :results-display="formatDisplay"
                  @selected="setXHRValueTown"
                  :resultsValue="contact.town"
                  placeholder="veuillez saisir une adresse"
                ></autocomplete>
              </b-form-group>
              <b-form-group label="Commune" label-cols="4" label-for="town">
                <b-form-input name="town" type="text" v-model="contact.town" disabled />
              </b-form-group>
              <b-form-group label="Code postal" label-cols="4" label-for="zipCode">
                <b-form-input name="zipCode" type="number" v-model="contact.zipCode" disabled />
              </b-form-group>
              <b-form-group label="Rue" label-cols="4" label-for="street">
                <b-form-input name="street" type="text" v-model="contact.street" disabled />
              </b-form-group>
              <b-form-group label="N° Police" label-cols="4" label-for="numberStreet">
                <b-form-input name="numberStreet" type="text" v-model="contact.numberStreet" />
              </b-form-group>
            </div>
          </div>
          <div class="pull-left">
            <b-link class="btn btn btn-cta btn-secondary s-btn" @click.stop="addContact">
              <v-icon name="plus-circle" class="nok" />
              {{ $t('addContact') }}
            </b-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { contactValues } from '../../params';
import { mapGetters, mapActions } from 'vuex';
import Autocomplete from 'vuejs-auto-complete';
export default {
  Name: 'PropertyFields',
  props: {
    propertyForm: { required: true },
    propertyFolderNumber: { required: false },
    title: { type: String, default: 'Propriété' },
  },
  components: {
    Autocomplete,
  },
  data() {
    return {
      currentContactIndex: '',
      cities: [],
      objectResults: null,
      apiResults: null,
      isLoading: false,
      selectedAdresse: {},
      adresses: [],
      selectedCodePostal: '',
      loaderData: true,
      loaderResponsibleData: true,
      options: contactValues,
      optionsGender: [
        { text: 'Monsieur', value: 'monsieur' },
        { text: 'Madame', value: 'madame' },
        { text: 'Autre', value: 'autre' },
      ],
      optionsCompliance: [
        { text: 'Oui', value: 'oui' },
        { text: 'Non', value: 'non' },
      ],
    };
  },
  computed: {
    ...mapGetters(['getPropertyTypes', 'getUsers', 'getTowns', 'getCities']),
  },
  mounted: function() {
    this.fetchPropertyTypes();
    this.fetchUsers();
    this.fetchTowns();
    this.fetchCities();
  },
  methods: {
    ...mapActions(['fetchTowns', 'fetchCities']),
    customLabel({ label }) {
      if (label) {
        return label.toUpperCase();
      }
    },
    setXHRValue(obj) {
      this.propertyForm.numberStreet = obj.selectedObject.properties.housenumber;
      if (obj.selectedObject.properties.street) {
        this.propertyForm.street = obj.selectedObject.properties.street;
      } else {
        this.propertyForm.street = obj.selectedObject.properties.name;
      }

      if (obj.selectedObject.geometry.coordinates) {
        this.propertyForm.longitude = obj.selectedObject.geometry.coordinates[1];
        this.propertyForm.latitude = obj.selectedObject.geometry.coordinates[0];
      }

      this.propertyForm.zipCode = obj.selectedObject.properties.postcode;
      this.$refs.autocomplete.value = this.propertyForm.numberStreet;

      this.$nextTick().then(() => {
        // Add the component back in
        let x = this.propertyForm.complianceSurveyOnly;
        this.propertyForm.complianceSurveyOnly = false;
        this.propertyForm.complianceSurveyOnly = x;
      });
    },
    currentContact(i) {
      this.currentContactIndex = i;
    },
    setXHRValueTown(obj) {
      this.propertyForm.contacts[this.currentContactIndex].town = obj.selectedObject.properties.city;
      if (obj.selectedObject.properties.street) {
        this.propertyForm.contacts[this.currentContactIndex].street = obj.selectedObject.properties.street;
      } else {
        this.propertyForm.contacts[this.currentContactIndex].street = obj.selectedObject.properties.name;
      }

      this.propertyForm.contacts[this.currentContactIndex].zipCode = obj.selectedObject.properties.postcode;
      this.propertyForm.contacts[this.currentContactIndex].numberStreet = obj.selectedObject.properties.housenumber;

      this.$nextTick().then(() => {
        // Add the component back in
        let x = this.propertyForm.complianceSurveyOnly;
        this.propertyForm.complianceSurveyOnly = false;
        this.propertyForm.complianceSurveyOnly = x;
      });
    },
    formatDisplay(result) {
      return result.properties.label;
    },
    urlFunction(input) {
      if (this.propertyForm.town && this.propertyForm.town.code) {
        let cp = this.getCities.find(p => p.code === this.propertyForm.town.code);
        if (cp) {
          return `${process.env.VUE_APP_BAN_API_URL}/search/?postcode=${cp.postalCode}&q=${input}`;
        }
      }
    },
    urlFunctionTown(input) {
      return `${process.env.VUE_APP_BAN_API_URL}/search/?q=${input}`;
    },
    fetchPropertyTypes() {
      return this.$store.dispatch('fetchPropertyTypes').then(() => (this.loaderData = false));
    },
    fetchUsers() {
      return this.$store.dispatch('fetchUsers').then(() => (this.loaderResponsibleData = false));
    },
    addContact: function() {
      this.propertyForm.contacts.push({
        typeContact: [{ value: 'maitre-ouvrage', name: "Maître d'ouvrage" }],
        otherTypeContact: null,
        title: 'monsieur',
        name: null,
        firstName: null,
        siret: null,
        businessName: null,
        fixedLinePhone: null,
        mobilePhone: null,
        email: null,
        town: null,
        zipCode: null,
        street: null,
        numberStreet: null,
      });
    },
    deleteContact: function(contact) {
      this.propertyForm.contacts.splice(this.propertyForm.contacts.indexOf(contact), 1);
    },
    checkOtherContactType(typeContact) {
      if (typeContact.length > 0) {
        let isExiste = typeContact.filter(type => type.value === 'autre');
        return isExiste.length > 0;
      }
    },
    isDigit: (event) => {
      if (event.code === 'Backspace' || /^\d+$/.test(event.key)) {
        return true;
      }

      event.preventDefault();
    },
  },
};
</script>
<style >
#app .txt-strong legend {
  font-weight: 600 !important;
}
legend#__BVID__108__BV_label_ {
  font-weight: 600;
}
</style>
